module.exports = __webpack_public_path__ + "img/style9.85883fed.png";